module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-2560-8ab1a2037b091e1a14a8e7936d399353.webp";